import { ComponentPropsWithRef, ForwardedRef } from "react";

export interface IconProps extends ComponentPropsWithRef<"svg"> {
  forwardRef?: ForwardedRef<SVGSVGElement>;
}

export const IconTriangleHorizontalFilled = ({
  forwardRef,
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.667"
      height="12"
      viewBox="0 0 10.667 12"
      ref={forwardRef}
      {...props}
    >
      <path
        id="パス_4711"
        data-name="パス 4711"
        d="M15,69.847,7,65.183a1.331,1.331,0,0,0-2,1.153v9.329a1.331,1.331,0,0,0,2,1.153L15,72.153A1.335,1.335,0,0,0,15,69.847Z"
        transform="translate(-5 -65)"
        fill="#fd632a"
      />
    </svg>
  );
};
